/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayerModelListResult } from '../../models/player-model-list-result';

export interface ApiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse$Params {
  ConferenceIds?: Array<number>;
  CompetitionId?: number;
  TeamIds?: Array<number>;
  PageSize?: number;
  PlayerName?: string;
}

export function apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: ApiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse.PATH, 'get');
  if (params) {
    rb.query('ConferenceIds', params.ConferenceIds, {});
    rb.query('CompetitionId', params.CompetitionId, {});
    rb.query('TeamIds', params.TeamIds, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('PlayerName', params.PlayerName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerModelListResult>;
    })
  );
}

apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse.PATH = '/api/player/players';
